/*
 * Copyright (c) 2019 brightlamp
 */

const AdminAccount = () => import(/* webpackChunkName: "admin-account" */ '@/views/admin-account');
const MessageCenterAdmin = () => import(/* webpackChunkName: "admin-account" */ '@/views/admin-account/message-center-admin-dashboard');
const Orgs = () => import(/* webpackChunkName: "admin-account" */ '@/views/admin-account/orgs');
const ResearchTests = () => import(/* webpackChunkName: "admin-account" */ '@/views/admin-account/research-tests');
const Users = () => import(/* webpackChunkName: "admin-account" */ '@/views/admin-account/users');

export default
[
    {
        path: '/admin-account',
        component: AdminAccount,
        meta:
        {
            requiresAuth: true,
            requiresAdmin: true
        },
        children:
        [
            {
                path: 'message-center-admin',
                name: 'Message Center Admin',
                component: MessageCenterAdmin,
                meta:
                {
                    title: 'Message Center Admin'
                }
            },
            {
                path: 'orgs',
                name: 'Orgs',
                component: Orgs,
                meta:
                {
                    title: 'Orgs'
                }
            },
            {
                path: 'research-tests',
                name: 'ResearchTests',
                component: ResearchTests,
                meta:
                {
                    title: 'Research Tests'
                }
            },
            {
                path: 'users',
                name: 'Users',
                component: Users,
                meta:
                {
                    title: 'Users'
                }
            }
        ]
    }
]